// extracted by mini-css-extract-plugin
export default {"landing-start-block-root":"LandingBlock_landing-start-block-root__IAFMs","background":"LandingBlock_background__kD+UG","intersection":"LandingBlock_intersection__vfYFW"};